// extracted by mini-css-extract-plugin
export default {"wrapper":"QgZ0MbLBjjTL2AZD9jATTQ==","focused":"giRT5Oat4nfVWPXvFewzcA==","title":"dISTINo97yPNQkvRbP+vhw=="};